var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex align-items-center"},[_c('asset-thumbnail',{attrs:{"image-url":_vm.asset.image_url}}),_c('div',[_c('router-link',{attrs:{"to":{
        name: 'asset-overview',
        params: {
          asset: _vm.asset.id,
        }
      }}},[_c('span',{staticClass:"has-text-weight-semibold"},[(_vm.asset.code)?_c('span',[_vm._v(_vm._s(_vm.asset.code))]):_vm._e(),(_vm.asset.barcode && !_vm.asset.code)?_c('span',[_vm._v(_vm._s(_vm.asset.barcode.data))]):_vm._e()])]),_c('div',{staticClass:"has-text-weight-normal has-text-grey-dark"},[_vm._v(_vm._s(_vm.subText))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }